import { CycleType } from '@wix/ambassador-premium-purchase-platform-v1-offering/types';
export let BrokerFeePriceErrors = /*#__PURE__*/function (BrokerFeePriceErrors) {
  BrokerFeePriceErrors["NO_ONE_TIME_PRICE"] = "noOneTimePrice";
  return BrokerFeePriceErrors;
}({});
const findOneTimePricing = function (pricingDetails) {
  if (pricingDetails === void 0) {
    pricingDetails = [];
  }
  return pricingDetails.find(_ref => {
    let cycle = _ref.cycle;
    return (cycle == null ? void 0 : cycle.cycleType) === CycleType.ONE_TIME;
  });
};
export const getBrokerFeeFormattedPrice = product => {
  var _pricing$finalPrice, _pricing$finalPrice2;
  const pricing = findOneTimePricing(product == null ? void 0 : product.pricingDetails);
  return (pricing == null || (_pricing$finalPrice = pricing.finalPrice) == null || (_pricing$finalPrice = _pricing$finalPrice.total) == null ? void 0 : _pricing$finalPrice.formattedAmount) ?? (pricing == null || (_pricing$finalPrice2 = pricing.finalPrice) == null || (_pricing$finalPrice2 = _pricing$finalPrice2.subtotal) == null ? void 0 : _pricing$finalPrice2.formattedAmount);
};
//# sourceMappingURL=brokerFeePrice.js.map